import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { Activity } from "@mapmycustomers/shared/types/entity";

import ActivitiesOverdueCardData from "@app/scene/dashboard/store/cards/activitiesOverdue/ActivitiesOverdueCardData";
import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import ActivitiesOverdueCardConfiguration from "@app/types/dashboard/cards/activitiesOverdue/ActivitiesOverdueCardConfiguration";
import Scope from "@app/types/dashboard/Scope";

export const fetchActivitiesOverdueCardData = createAction(
  "@dashboard/fetchActivitiesOverdueCardData"
)<{
  callback: (data: ActivitiesOverdueCardData) => void;
  configuration: ActivitiesOverdueCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showActivitiesOverdueDrillDown = createAsyncAction(
  "@dashboard/showActivitiesOverdueCardDrillDownModal/request",
  "@dashboard/showActivitiesOverdueCardDrillDownModal/success",
  "@dashboard/showActivitiesOverdueCardDrillDownModal/failure"
)<
  {
    configuration: ActivitiesOverdueCardConfiguration;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  unknown
>();

export const hideActivitiesOverdueDrillDown = createAction(
  "@dashboard/hideActivitiesOverdueCardDrillDownModal"
)<void>();

export const fetchActivitiesOverdueCardDrillDownData = createAsyncAction(
  "@dashboard/fetchActivitiesOverdueCardDrillDownData/request",
  "@dashboard/fetchActivitiesOverdueCardDrillDownData/success",
  "@dashboard/fetchActivitiesOverdueCardDrillDownData/failure"
)<
  DrillDownListFetcherPayload<Activity>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyActivitiesOverdueDrillDownListViewSettings = createAction(
  "@dashboard/applyActivitiesOverdueDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export const exportActivitiesOverdueCardDrillDownData = createAction(
  "@dashboard/exportActivitiesOverdueCardData"
)<{
  configuration: ActivitiesOverdueCardConfiguration;
  scope: Scope;
}>();

export type ActivitiesOverdueCardActions = ActionType<
  | typeof applyActivitiesOverdueDrillDownListViewSettings
  | typeof exportActivitiesOverdueCardDrillDownData
  | typeof fetchActivitiesOverdueCardData
  | typeof fetchActivitiesOverdueCardDrillDownData
  | typeof hideActivitiesOverdueDrillDown
  | typeof showActivitiesOverdueDrillDown
>;
